import React, { useEffect, Fragment } from 'react';
import ReactTooltip from 'react-tooltip';
import { useHistory } from 'react-router-dom';

function SerbiaMap(props) {
  const history = useHistory();
  useEffect(() => {
    ReactTooltip.rebuild();
  }, []);
  const handleClick = region => {
    history.push(`/companies?region=${region}`);
  };
  return (
    <Fragment>
      <ReactTooltip id="zapadnoBacki" type="success">
        <span>
          Zapadnobački okrug <br></br> Broj kompanija: 12
        </span>
      </ReactTooltip>
      <ReactTooltip id="severnoBacki" type="success">
        <span>
          Severnobački okrug <br></br> Broj kompanija: 9
        </span>
      </ReactTooltip>
      <ReactTooltip id="severnoBanatski" type="success">
        <span>
          Severnobanatski okrug <br></br> Broj kompanija: 16
        </span>
      </ReactTooltip>
      <ReactTooltip id="juznoBacki" type="success">
        <span>
          Južnobački okrug <br></br> Broj kompanija: 41
        </span>
      </ReactTooltip>
      <ReactTooltip id="srednjeBanatski" type="success">
        <span>
          Srednjebanatski okrug <br></br> Broj kompanija: 9
        </span>
      </ReactTooltip>
      <ReactTooltip id="juznoBanatski" type="success">
        <span>
          Južnobanatski okrug <br></br> Broj kompanija: 5
        </span>
      </ReactTooltip>
      <ReactTooltip id="sremskiOkrug" type="success">
        <span>
          Sremski okrug <br></br> Broj kompanija: 14
        </span>
      </ReactTooltip>
      <ReactTooltip id="macvanskiOkrug" type="success">
        <span>
          Mačvanski okrug <br></br> Broj kompanija: 4
        </span>
      </ReactTooltip>
      <ReactTooltip id="kolubarskiOkrug" type="success">
        <span>
          Kolubarski okrug <br></br> Broj kompanija: 4
        </span>
      </ReactTooltip>
      <ReactTooltip id="beogradskiOkrug" type="success">
        <span>
          Beograd <br></br> Broj kompanija: 21
        </span>
      </ReactTooltip>
      <ReactTooltip id="podunavskiOkrug" type="success">
        <span>
          Podunavski okrug <br></br> Broj kompanija: 1
        </span>
      </ReactTooltip>
      <ReactTooltip id="pomoravskiOkrug" type="success">
        <span>
          Pomoravski okrug <br></br> Broj kompanija: 2
        </span>
      </ReactTooltip>
      <ReactTooltip id="sumadijskiOkrug" type="success">
        <span>
          Šumadijski okrug <br></br> Broj kompanija: 2
        </span>
      </ReactTooltip>
      <ReactTooltip id="moravickiOkrug" type="success">
        <span>
          Moravički okrug <br></br> Broj kompanija: 5
        </span>
      </ReactTooltip>
      <ReactTooltip id="raskiOkrug" type="success">
        <span>
          Raški okrug <br></br> Broj kompanija: 3
        </span>
      </ReactTooltip>
      <svg
        xmlSpace="preserve"
        width={400}
        height={450}
        viewBox="0 0 8.5 11.778"
        id="prefix__svg2"
        fillRule="evenodd"
        {...props}
      >
        <defs id="prefix__defs4">
          <style type="text/css" id="style6">
            {
              '.prefix__str0{stroke:#fff;stroke-width:.0138898}.prefix__fil2{fill:#aaa9a9}.prefix__fil1{fill:#aaa9a9}.prefix__fil0{fill:#8E9699}'
            }
          </style>
        </defs>
        <g id="prefix__g4076" transform="translate(-.025 -.302)">
          <path
            data-tip
            data-for="zapadnoBacki"
            onClick={() => handleClick('zapadnoBacki')}
            id="zapadnoBacki"
            className="prefix__fil0 prefix__str0"
            d="M1.32 1.503c-.022-.002-.041-.073-.067-.062a.399.399 0 01-.2-.01c-.063-.033-.02-.109-.096-.105-.036.002-.096.12-.07.175.022.05-.085.04-.12.062-.072.042-.195.038-.281.07 0 .115.033.461.193.562.117.074-.145.051-.103.28.095.128.18-.014.206.032.036.067.125.079.12.104-.02.102-.133-.014-.169.038-.01.015-.023.042-.014.039.069-.026.189.111.277.093.055-.01.091.06.148.04.04-.013.165.018.226-.036.053-.046.04-.175.112-.222.04-.027.08.048.116.02.035-.028.1-.078.128-.13.032-.06.03-.124.048-.154.05-.077-.06-.191-.106-.242-.024-.028-.04.023-.097 0-.042-.017-.14-.141-.19-.25a.291.291 0 01-.024-.16c.014-.078.025-.138-.037-.144h0z"
            fill="#d38d5f"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
          />

          <path
            data-tip
            data-for="sremskiOkrug"
            onClick={() => handleClick('sremskiOkrug')}
            id="prefix__rs-_0"
            className="prefix__fil0 prefix__str0"
            d="M1.447 3.454c-.126.056-.226-.208-.23-.083-.003.148-.144-.016-.201.012-.046.023.005.135-.029.146-.071.023-.112-.04-.13-.031.043.096.008.194.016.282.003.028-.088.129-.054.129.313-.003.089.155.052.175-.025.013-.066-.019-.105-.031-.065-.021-.12-.017-.027.146.093-.041.174-.097.27-.122.07-.019.043.023.1.03.058.008.18-.034.195.006a.245.245 0 00.16-.09c.016-.02.105.121.114.097.057-.142.08.037.19-.016.09-.041.287-.024.26.029-.02.038-.104.138-.121.22-.013.063.033.113.062.138.022.02.055.024.095.018.072-.01.102.128.216.14.036.003.08-.015.127-.01.103.013-.094.08-.12.12-.03.047.026.054.05.043.022-.012.027.015.095-.049a1.52 1.52 0 00.059-.06c.03-.032.087-.034.116-.067.043-.049.057-.127.064-.137.01-.014-.097-.069-.086-.084.021-.027.082-.018.103-.047.034-.046-.016-.062.012-.11.02-.037.045-.076.07-.113.027-.04.066-.023.09-.056.018-.025.072-.015.086-.04.016-.027-.007-.09-.003-.096.012-.02.114-.037.131-.083.016-.04-.05-.111-.05-.14 0-.04-.047-.017-.055-.057a.348.348 0 00-.048-.12c-.033-.05-.12-.078-.188-.09-.033-.005-.035-.027-.066-.026-.026 0-.04.042-.063.043a.674.674 0 01-.084.004c-.015-.002.008-.019.01-.044.004-.033-.01-.077-.016-.07-.075.087-.062.14-.12.158-.08.024-.085-.014-.174-.016-.103-.002-.285.018-.37.018-.111 0-.159-.052-.224-.064-.038-.006-.039.013-.076.003-.03-.009-.048.066-.066.047-.062-.065-.033-.054-.037-.052h0z"
            fill="#c87137"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
          />
          <path
            data-tip
            data-for="severnoBacki"
            onClick={() => handleClick('severnoBacki')}
            id="prefix__rs-_1"
            className="prefix__fil0 prefix__str0"
            d="M1.952 1.012c-.05-.002-.208-.03-.287.044-.05.048.004.066-.05.11a1.136 1.136 0 00-.154.146c-.067.082-.097-.033-.152.016-.045.041-.03.102-.056.113-.011.005.033.042.067.062.02.012.028.002.041.025.03.051.01.154-.007.146-.026-.013.015.126.086.237a.433.433 0 00.13.145c.161.038.05-.033.082-.008.025.021.104.1.128.165.014.039-.03.08-.005.086.04.009.18.118.235.07.017-.016.012-.074.028-.12.011-.035.047-.058.05-.088.005-.042-.02-.06-.005-.068.043-.022.13-.03.16-.083.013-.023-.093-.087-.09-.133.002-.019.026-.047.019-.069-.007-.022-.044-.04-.041-.062.005-.035.031-.038.039-.073.012-.06-.026-.088-.015-.145.019-.094.085-.205.084-.21-.01-.036.066-.257.03-.233-.036.024-.069.042-.11.04-.114-.006-.108-.126-.207-.113h0z"
            fill="#a05a2c"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
          />
          <path
            data-tip
            data-for="juznoBacki"
            onClick={() => handleClick('juznoBacki')}
            id="prefix__rs-_2"
            className="prefix__fil0 prefix__str0"
            d="M1.439 2.617c-.01.026-.038.157-.098.186-.032.016-.18.017-.219.022-.029.004-.016-.021-.098-.043C.982 2.775.99 2.781.952 2.78c-.033 0-.204-.12-.222-.094-.023.034.076.226-.044.231-.036.011.055.112.193.12.048.002.02.057.05.1.029.043.118.076.147.089.3.139.276.058.342.095.109.062.079.114.03.134-.026.01.073.053.052.053-.053 0 .007-.022.05-.048.015-.01.036.002.065-.002.041-.007.105.06.261.065.09.003.223-.023.324-.02.073 0 .12.034.174.022.094-.022.096-.105.125-.151.032-.051-.003-.006.031.057.005.008-.033.03-.01.044.023.012.075-.001.087-.006.013-.006.033-.038.06-.041.018-.002.039.02.066.027.018.004.046 0 .078.016.067.034.142.107.116.063-.006-.01.003-.043.058-.084.014-.01.017-.053.023-.07.007-.018-.062-.09-.06-.11.002-.02-.095-.099-.092-.12.003-.03.067-.043.066-.076 0-.015-.114-.066-.115-.083l-.002-.038c-.001-.016.035-.044.034-.06l-.003-.029c-.003-.019-.085.012-.088-.006-.003-.02-.016-.024-.019-.045-.006-.042.028-.037.02-.078-.01-.043-.1-.06-.109-.1-.003-.013-.045.098-.048.085-.002-.01-.026.014-.028.004l-.01-.048c-.002-.012.03-.09.029-.102-.002-.01-.023-.01-.024-.022-.004-.022.132-.061.128-.083-.002-.012-.017-.023-.02-.036-.002-.016-.081.041-.084.025-.003-.018-.012-.026-.015-.044-.001-.008.058-.03.057-.039l-.007-.043c-.002-.013-.09.036-.091.024l-.006-.04c-.001-.013.12-.043.119-.055-.004-.031-.01-.06-.013-.088-.001-.008.062-.033.06-.042-.018-.107-.186-.046-.2-.072-.023-.039-.127-.048-.193-.047-.01 0-.05-.011-.05-.001-.001.03-.134.078-.161.083-.013.003.013.04.005.068-.013.05-.042.055-.052.095-.007.027-.01.084-.033.118-.008.01-.047.015-.103-.013-.05-.025-.095-.053-.125-.062-.013-.004-.011.035-.021.072a.545.545 0 01-.04.101c-.018.034-.032.042-.075.077-.016.015-.029.03-.05.04-.022.008-.061-.031-.085-.032-.036-.001-.056.034-.065.06h0z"
            fill="#784421"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
          />
          <path
            data-tip
            data-for="severnoBanatski"
            onClick={() => handleClick('severnoBanatski')}
            className="prefix__fil0 prefix__str0"
            id="prefix__polygon14"
            fill="#deaa87"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M3.532 2.157l.021-.093.032-.086v-.09l-.04-.089-.074-.021-.018-.108-.047.043-.06-.021-.033-.09-.046-.06-.104.003-.075-.075-.036-.1-.035-.09-.065-.057v-.06l-.075-.036-.093-.075-.06.05-.069-.086-.043.072-.068-.008-.032-.071-.103-.004-.086.029-.054.05.012.013-.011.054-.016.067-.016.096-.04.092-.041.116-.004.031.019.088-.006.043-.031.048-.003.024.04.052-.018.07.006.024.087.101.047.008.117.007.063.026.02.019.11.002.058.017.013.017.012.031h0l.054.005.04-.046-.076-.043.025-.06.1.003.119-.022.118-.018.025.072.05.104.057.064-.075.06-.057-.02.017.07-.053.058.018.05.114.004.104-.036.107.01-.018-.046v-.1l.04-.036.043-.06.06.046z"
          />
          <path
            data-tip
            data-for="srednjeBanatski"
            onClick={() => handleClick('srednjeBanatski')}
            className="prefix__fil0 prefix__str0"
            id="prefix__polygon16"
            fill="#e9c6af"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M4.037 3.147l-.144.093.045.039-.058.055-.104.056-.07.098-.085-.09-.03-.043-.112-.035-.033.006v.07l-.12-.025-.067.12-.068.148-.04.053-.042-.025-.087.04-.037-.022-.034-.084-.024-.068.019-.048.04-.036.022-.07-.052-.089-.008-.022L2.9 3.21l-.045-.06.046-.045.02-.031-.058-.041-.045-.029-.013-.032-.001-.02.034-.058-.003-.03h-.074l-.033-.05.02-.079-.045-.045-.043-.028-.02-.027-.05.085-.027.004-.01-.048.029-.102-.024-.022.128-.083-.02-.036-.084.025-.015-.044.057-.039-.007-.043-.077.023-.017-.02.005-.027.11-.047-.012-.088.06-.042.054.005.04-.046-.076-.043.025-.06.1.003.237-.04.075.176.057.064-.075.06-.057-.02.017.07-.053.058.018.05.114.004.104-.036.107.01-.018-.046v-.1l.04-.036.045-.059.058.045.033-.032.021-.093.032-.086V1.95h0l.071.058.006.061.066.007.07-.031.015-.072.057.037-.035.121-.012.136.02.057-.06.093.011.023.1.104.013.06-.136.076.015.043.109.009.061.049-.006.058.103.07.027.084.103.076.01.041-.084.023z"
          />
          <path
            data-tip
            data-for="juznoBanatski"
            onClick={() => handleClick('juznoBanatski')}
            className="prefix__fil0 prefix__str0"
            id="prefix__polygon18"
            fill="#deaa87"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M4.477 4.493l-.031.062-.063-.05-.07.078-.149-.004-.129.121-.168.043-.129-.027-.148-.18-.055-.035v-.117l-.086-.102.016-.05.047.01v-.148l-.141-.082-.086-.101-.117-.125-.018-.094.175-.32.121.024v-.07l.033-.006.111.035.116.133.07-.098.104-.056.058-.055-.045-.04.144-.092.156-.037h.096l.067.074.105-.078.059.023.015.14.13.06.234.027.191.133v.062l-.109.07v.11l-.05.09-.15.011.15.153.16.055.054.078-.015.054-.086.028-.16.008-.087.03v.09l-.097.079-.153.02z"
          />
          <path
            data-tip
            data-for="macvanskiOkrug"
            onClick={() => handleClick('macvanskiOkrug')}
            className="prefix__fil0 prefix__str0"
            id="prefix__polygon20"
            fill="#a05a2c"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M1.562 5.381l.028-.108-.051-.034.136-.04.08.063.113-.04.114.046.136.08h.062l.04-.2-.034-.147.085-.08.062.04.091-.073-.035-.1-.1.013-.001-.043.147-.109-.028-.01-.127.01-.067-.026-.112-.105-.086-.008-.096-.08-.012-.077.052-.115.07-.105-.053-.045-.093-.016-.114.032-.07.004-.055-.036-.034-.003-.032.051-.056-.049-.058-.048-.044.042-.116.048h0l.042.065-.13.221.04.12-.177.306-.181.284.04.176-.092.113.114.25.062-.028.04.062.17-.028.063.215.153.16.023-.069.045.142.199-.13.048.009.003-.066-.074-.057v-.085l-.244-.097.125-.187-.08-.096z"
          />
          <path
            data-tip
            data-for="beogradskiOkrug"
            onClick={() => handleClick('beogradskiOkrug')}
            className="prefix__fil0 prefix__str0"
            id="prefix__polygon22"
            fill="#28170b"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M3.15 3.692l-.04-.025-.088.04.052.153-.131.083.003.097-.086.039-.09.056-.07.112-.012.111-.103.047.098.084-.076.137-.116.068-.102.094.035.1.003.113.114.072.12-.075.038.106.106-.04.07.166-.078.128.004.166.13.185.204-.108.116-.33h0l.131.08.018.06.13-.017.055.093.214.059.024-.265.106-.059-.215-.218.03-.069.123-.008-.05-.088.05-.096-.129-.027-.148-.18-.055-.035v-.117l-.086-.102.016-.05.047.01v-.148l-.141-.082-.086-.101-.117-.125z"
          />
          <path
            data-tip
            data-for="kolubarskiOkrug"
            onClick={() => handleClick('kolubarskiOkrug')}
            className="prefix__fil0 prefix__str0"
            id="prefix__polygon24"
            fill="#deaa87"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M2.805 5.064l.07.166-.078.128.004.166.13.185.204-.108.061.14-.275.252-.174.005-.083.131-.13-.09-.137.04-.154-.113-.139.02-.018.225-.079-.195-.241-.101h0l-.074-.057v-.085l-.244-.097.125-.187-.08-.096.069-.012.028-.108-.051-.034.136-.04.08.063.113-.04.114.046.136.08h.062l.04-.2-.034-.147.085-.08.062.04.091-.073.117.185.12-.075.038.106z"
          />
          <path
            data-tip
            data-for="podunavskiOkrug"
            onClick={() => handleClick('podunavskiOkrug')}
            className="prefix__fil0 prefix__str0"
            id="prefix__polygon26"
            fill="#502d16"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M4.035 4.7l.13-.121.073.002h0l.043.22.135.127.015.166.046.158-.053.098-.047.098.1-.008.02.06-.105.08.044.092.013.132-.05.035-.222-.12-.028-.054-.168.003-.182-.122.024-.265.106-.059-.215-.218.03-.069.123-.008-.05-.088.05-.096z"
          />
          <path
            className="prefix__fil1 prefix__str0"
            id="prefix__polygon28"
            fill="#e9c6af"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M5.493 6.07l-.13.004-.008-.046-.198-.025V5.94l-.184-.126-.16.016v-.058l-.042-.05-.02-.076-.051-.038-.042.088-.072-.013-.012-.046-.038-.042-.144-.015.106-.08-.022-.06-.099.008.1-.196-.046-.158-.015-.166-.135-.128-.043-.22.075.003.07-.078.063.05.03-.062.071-.066.153-.02.097-.078h0l.05.04.02.085.332.016.046.126-.004.101.072.055.23-.02.374.057.055.093-.139.155-.025.185-.172.096-.067.118.063.109.109.03.042.213.088-.067.033.139-.046.088.034.076-.067.042-.055.004-.15.058z"
          />
          <path
            className="prefix__fil1 prefix__str0"
            id="prefix__polygon30"
            fill="#f4e3d7"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M5.579 6.227l.003.066.097.026.094-.02.028.075.154.06.06-.036.038.137.116.045.046-.066.02-.048.07-.13.056-.11-.001-.183-.069-.046.081-.114.169.08.113-.036.163.15-.067.06.021.077h.115l.15-.071.005-.228.037-.092.087-.138-.065-.064-.17-.015-.097-.13-.016-.125-.073-.094-.016-.094.158-.02.022-.107.032-.059.08-.014.138.093.123-.062-.163-.172-.183-.045h0l-.166-.188-.088-.007-.089.113-.106-.008-.114.182-.1.264-.113.061-.151-.2-.036-.112-.139.155-.025.185-.172.096-.067.118.063.109.109.03.042.213.088-.067.033.139-.046.088.034.076-.067.042-.055.004-.15.058z"
          />
          <path
            data-tip
            data-for="pomoravskiOkrug"
            onClick={() => handleClick('pomoravskiOkrug')}
            className="prefix__fil0 prefix__str0"
            id="prefix__polygon32"
            fill="#d38d5f"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M4.7 5.608l-.042.088-.072-.013-.012-.046-.038-.042-.144-.015.044.092.013.132h0l-.05.035.013.15.075.002.02.072-.191.083.074.08-.02.089-.092.025.006.105-.078.117.02.095-.17.123.012.097.044.09.328.053.008-.074.06.002.097-.074.056-.143h0l.033.146.124-.058.03.092.062.07.135-.067.126-.101.185-.042.053-.08-.02-.138.078-.001.115-.259-.003-.066.04-.099-.126-.058-.13.004-.008-.046-.198-.025V5.94l-.184-.126-.16.016v-.058l-.042-.05-.02-.076z"
          />
          <path
            data-tip
            data-for="sumadijskiOkrug"
            onClick={() => handleClick('sumadijskiOkrug')}
            className="prefix__fil0 prefix__str0"
            id="prefix__polygon34"
            fill="#a05a2c"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M4.37 6.315l-.092.025.006.105-.078.117.02.095-.17.123-.078-.084-.207.018.036.066-.045.058-.072-.001-.136-.186-.176-.237h0l.128-.124.043-.058-.166-.152-.008-.046-.045-.109-.066-.013-.034-.06-.034-.111-.061-.14.116-.33.279.123h0l.055.093.214.059.182.122.168-.003.028.054.221.12.014.15.075.002.02.072-.191.083.074.08z"
          />
          <path
            data-tip
            data-for="moravickiOkrug"
            onClick={() => handleClick('moravickiOkrug')}
            className="prefix__fil0 prefix__str0"
            id="prefix__polygon36"
            fill="#deaa87"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M3.17 7.956l-.071.047-.062.117-.168.055h0L2.856 8.1l.06-.062-.021-.053-.255.047-.05-.053.03-.062-.194-.353-.158-.11.033-.107.093.037.108-.11.079-.02.026-.09.112.045.038-.05.008-.15-.087-.079.004-.132-.074-.144.024-.216-.09-.083.026-.114.007-.173.089.061.083-.13.174-.006.275-.252.034.111.034.06.066.013h0l.045.109.008.046.166.152-.17.182.158.215.017.022-.078.032-.052.128-.099.054-.056.093-.093.014.026.117.021.053-.04.043-.058-.032-.048.05.03.12-.014.044-.095.084.115.085.057.131-.006.106.014.078z"
          />
          <path
            className="prefix__fil2 prefix__str0"
            id="prefix__polygon38"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M1.02 7.496l-.003.09.399.272.05.124.096.024-.002.111.053.063.055.014.065.054.07.096.106.02.095.01L2 8.461l.096.07.06-.024.065.058.117-.076.023.112.023.093.08-.003.039.072.094-.218.102-.02.035-.108.192-.05-.12-.134.062-.06-.013-.074.06-.062-.021-.053-.255.047-.05-.053.03-.062-.194-.353-.158-.11.033-.107.093.037.108-.11.079-.02.026-.09.112.045.038-.05.008-.15-.087-.079.004-.132-.074-.144.024-.216-.09-.083.026-.114.007-.173-.041-.029-.137.04-.154-.113-.139.02-.018.225-.079-.195-.241-.101h0l-.003.066-.048-.01-.199.131.145.084.045-.028.04.072-.012.069-.207.146H1.39l-.31-.154.042.165.43.594.024.12-.066.08.028.085-.15.025-.038.083-.075-.148-.081.033-.092-.017-.03.03-.014.125z"
          />
          <path
            data-tip
            data-for="raskiOkrug"
            onClick={() => handleClick('raskiOkrug')}
            className="prefix__fil0 prefix__str0"
            id="prefix__polygon40"
            fill="#deaa87"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M3.17 7.956l-.071.047-.062.117-.168.055h0l-.061.06.119.132-.192.051-.035.108-.102.02-.094.218.086.108.071-.07.022.055.306.154.027.151.163.043.17-.12-.092-.142.046-.063.075-.003.05-.12.165-.046-.025-.093.07-.03-.01-.058-.121-.142-.016-.102.135.003.081-.099.085-.003.068-.074.046-.125-.01-.155-.087-.048-.015-.082.033-.05-.043-.135.094-.01.108.026.081-.018-.029-.22.066-.013-.107-.13.035-.064.032-.086.048-.035-.044-.09-.013-.098-.077-.084h0l-.207.018.036.066-.045.058-.072-.001-.124-.17-.012-.016-.078.032-.052.128-.099.054-.056.093-.093.014.026.117.021.053-.04.043-.058-.032-.048.05.03.12-.014.044-.095.084.115.085.057.131-.006.106.014.078z"
          />
          <path
            className="prefix__fil1 prefix__str0"
            id="prefix__polygon42"
            fill="#f4e3d7"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M5.679 6.319l.094-.02.028.075.154.06.06-.036.038.137.116.045.046-.066.02-.048.07-.13.056-.11-.001-.183-.069-.046.081-.114.169.08.113-.036.163.15-.067.06.021.077h.115l-.02.055-.168.017-.03.047.003.119-.037.153-.057.193.077.138.024.14.12.117.06.364.102.093.104.071.07-.01.01.082-.137.131-.071.036-.093-.097-.097.058h0l-.16-.08-.03-.104-.045-.088-.074.03-.097-.087h0l-.11.045-.095-.093-.095.002-.027-.093-.078-.108-.007.136-.128.04-.066-.174-.165.003-.042-.061-.11-.171.009-.22-.07-.127.053-.08-.02-.138.078-.001.115-.259z"
          />
          <path
            id="prefix__polygon44"
            className="prefix__fil2 prefix__str0"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M5.084 7.292l.076.004-.001.147.057.024-.06.163.063.088-.167.123.033.067h.17l-.038.103.08.065.006.105.105.056.04-.098.125.01-.013.163.074.137.153-.067.028.096.035-.067.142-.001.197.159.111.037.084-.012.042-.095.06.003-.03-.11-.09.015-.185-.157.04-.095.039-.05-.04-.127.013-.072.196.09.1-.04h0l.057-.116-.03-.103-.045-.088-.074.03-.097-.087h0l-.11.045-.095-.093-.095.002-.027-.093-.078-.108-.007.136-.128.04-.066-.174-.165.003-.042-.061-.11-.171.009-.22-.07-.127-.185.042-.126.101.046.115-.08.081z"
          />
          <path
            className="prefix__fil2 prefix__str0"
            id="prefix__polygon46"
            fill="#c87137"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M5.084 7.292l.076.004-.001.147.057.024-.06.163.063.088-.167.123-.059.004-.069-.038-.051.024-.05-.04-.162.075-.088.027-.019.079-.068.056-.021.082-.103.083-.07-.055-.068.034-.04-.046-.027.07-.05.05.015.108-.085.075-.127-.056-.004-.056.078-.053-.124-.15.046-.126-.01-.155-.087-.048-.015-.082h0l.033-.05-.043-.135.094-.01.108.026.081-.018-.029-.22.066-.013-.107-.13.035-.064.032-.086.048-.035.328.052.008-.074.06.002.097-.074.056-.143.033.146.124-.058.03.092.062.07.135-.067.046.115-.08.081z"
          />
          <path
            className="prefix__fil2 prefix__str0"
            id="prefix__polygon48"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M5.303 8.181l-.005-.105-.081-.065.039-.103h-.17l-.034-.067-.059.004-.069-.038-.051.024-.05-.04-.162.075-.088.027-.019.079-.068.056-.021.082-.103.083-.07-.055-.068.034-.04-.046-.027.07-.05.05.015.108-.085.075.087.067.063-.041.098.08.055-.019-.015-.064.076.054.071.06-.04.05h0l.068.165.045-.059.093.071-.03.077.046.12.052.07.082-.027.066.07.142.016-.004-.132.033-.086-.036-.077.095-.019.047-.084.091.005.069-.078.088-.012.218-.133.037-.054-.074-.137.013-.162-.125-.01-.04.097z"
          />
          <path
            className="prefix__fil2 prefix__str0"
            id="prefix__polygon50"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M6.432 8.804l.207.034.035.06-.05.045.093.092.208.057.042-.044.03.051.045-.05.07-.045.027.058.08.013.092-.036.056-.088.03-.133.071-.036.05-.078.063-.046.04-.086.002-.06.067-.002.048-.05.016-.083-.021-.05.04-.043-.111-.012-.103-.084-.096-.159h0l-.044-.105-.083-.039-.034-.051-.082-.03-.077-.01-.136.13-.071.036-.093-.097-.097.058-.16-.08-.157.154-.196-.09-.013.073.04.128-.039.05-.04.094.184.157.121.095-.06-.003-.042.095.06.039-.088.045-.034.046z"
          />
          <path
            className="prefix__str0"
            id="prefix__polygon52"
            className="prefix__fil2 prefix__str0"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M6.189 8.569l.111.037.084-.012.06.039-.088.045-.034.046.11.08.207.034.035.06-.05.045.093.092.208.057-.054.058-.094.056-.118.032-.042.067-.105.042-.028.06-.117-.108-.067-.047-.072.056-.02-.102-.073-.013-.085.068-.066-.057-.065.105-.122-.018-.105.031-.06.04-.063.164-.147.018-.056.054-.016-.063-.092-.005h0l-.002-.06-.074-.023-.136-.011-.076-.045-.087.018.017-.058.03-.083v-.083l.066-.066-.004-.132.033-.086-.036-.077.095-.019.047-.084.091.005.069-.078.088-.012.218-.133.037-.054.153-.067.028.096.035-.067.142-.001z"
          />
          <path
            className="prefix__fil1 prefix__str0"
            id="prefix__polygon54"
            fill="#e9c6af"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.014}
            d="M6.498 10.296l.057.085.06.06.178-.016.034-.085.02-.106.078.018.035-.15.044-.041-.065-.102-.063-.033-.028-.067-.072-.043.048-.112-.01-.164.07-.121-.08-.1-.027-.113-.118.032-.042.067-.105.042-.028.06-.117-.108-.067-.047-.072.056-.02-.102-.073-.013-.085.068-.066-.057-.065.105-.122-.018-.105.031-.06.04-.063.164.057.151-.097.028-.062.187-.055.087h0l-.066.095-.04.124.055.064-.068.043-.068.014-.075.058.008.07.057.04.051.106.175.075.076-.094.057.034.019-.075.078-.035.038-.06.07.039.07.012.057-.089.071.05.069.035.093.008.198-.092.093-.028z"
          />
          <path
            id="prefix__path3242"
            className="prefix__fil2 prefix__str0"
            d="M3.752 9.793l-.107-.165-.128-.087.012-.198.042-.152-.095-.108h-.124l-.103-.132.054-.074h.07l.05-.12.168-.057-.029-.083.066-.029v-.062l-.127-.14-.017-.107.144.008.075-.099.095-.004.057-.07.132.148-.082.054.004.054.124.053.078.062.041.062.058.054.046.115.107.149-.05.16.03.157.073.062-.094.136-.013.103-.144.104-.149-.042-.086-.004-.054.091-.124.16z"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.011}
            strokeLinecap="butt"
            strokeLinejoin="miter"
            strokeMiterlimit={4}
            strokeOpacity={1}
            strokeDasharray="none"
          />
          <path
            id="prefix__path4029"
            d="M5.262 10.597l-.111.07-.074-.107-.079.03.004.102-.082-.053-.05.045-.21-.128-.008-.194.09-.041-.053-.223.029-.21.185-.198.124.029v-.087l-.087-.103.161-.09.079.003.07.025.004.062.099.004.004.062.066-.058.149-.016.057.152-.094.033-.066.19-.133.186-.033.107.062.07-.082.054-.074.012-.066.07.016.054.062.041.041.107z"
            className="prefix__fil2 prefix__str0"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.011}
            strokeLinecap="butt"
            strokeLinejoin="miter"
            strokeOpacity={1}
          />
          <path
            id="prefix__path4044"
            d="M3.744 9.789l.099-.004v.206l.268.16.008.195.058.156.145-.02.152.115-.078.14.198.215.008.074.145-.066.123-.28-.214-.128-.004-.194.09-.041-.057-.235.033-.207.185-.19.132.042v-.1l-.099-.102.132-.075-.095-.066-.094.025.057-.148-.004-.079.066-.066-.132-.012-.082-.079-.075.034-.057-.083-.042-.103.03-.079-.096-.074-.045.054-.07-.161.045-.05-.152-.12.012.067-.054.025-.099-.079-.062.037.087.108.054.132.103.127-.054.17.037.144.075.074-.104.136-.008.095-.144.112L4 9.537H3.92l-.177.252z"
            className="prefix__fil2 prefix__str0"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.011}
            strokeLinecap="butt"
            strokeLinejoin="miter"
            strokeOpacity={1}
          />
          <path
            id="prefix__path4059"
            d="M4.392 10.733l-.627.405-.013.433-.235.07-.09-.181.11-.095-.263-.726.235-.182-.153-.074-.045-.272.033-.1.272-.065.112.11.12-.073.267.169v.181l.062.17.14-.034.165.128-.09.136z"
            className="prefix__fil2 prefix__str0"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.011}
            strokeLinecap="butt"
            strokeLinejoin="miter"
            strokeOpacity={1}
          />
          <path
            id="prefix__path4061"
            d="M3.27 10.634l-.273-.185-.156.016L2.692 10l-.144-.045-.009-.165.062-.153-.165-.144.074-.17.302.095.078-.086-.012-.066.14-.107.16.045.166-.128.136.004.09.112-.04.156-.013.186.136.107.087.145.107-.005v.203l-.111.074-.12-.111-.276.066-.03.09.042.28.161.075-.243.177z"
            className="prefix__fil2 prefix__str0"
            fillOpacity={1}
            stroke="#fff"
            strokeWidth={0.011}
            strokeLinecap="butt"
            strokeLinejoin="miter"
            strokeOpacity={1}
          />
          <path
            d="M5.273 10.617l-.05-.124-.061-.05-.013-.05.056-.061.08-.031.081-.044-.056-.068.031-.123.13-.174.068-.186.1-.03-.075-.155-.136.018-.068.056-.006-.062-.093-.006-.006-.062-.1-.031-.08.012-.1-.055-.092.012.05-.124V9.18L5 9.112l-.13-.006-.087-.08-.062.03h-.019l-.05-.08-.042-.1.03-.08-.099-.074-.043.043-.068-.154.043-.05-.148-.111v.061l-.037.025-.1-.086-.061.043-.087-.068-.124-.062-.012-.044.08-.049-.124-.161-.068.068-.086.006-.08.1h-.15l.025.11.118.137.006.062-.062.025.025.093-.173.05-.038.11-.08.007-.05.074.093.124-.16.124-.193-.044"
            id="prefix__path2849"
            fill="none"
            stroke="#fff"
            strokeWidth={0.044}
            strokeLinecap="butt"
            strokeLinejoin="miter"
            strokeMiterlimit={4}
            strokeOpacity={1}
            strokeDasharray="none"
          />
          <path
            d="M1.274 4.12l.156-.058.043-.049.113.124.016-.07h.027l.075.048.177-.043.124.022.027.038-.08.112-.05.113.022.08.092.076h.09l.114.123.059.011.134-.005.016.021-.15.097.01.043.103-.016.112-.108.102-.053.07-.14-.091-.075.102-.054.01-.107.087-.124.16-.086-.005-.096.14-.081-.059-.156.091-.043.043.032.022.097.193.22.14.086.005.145-.053-.005-.006.06.08.085v.124l.07.043.13.155.123.043.177-.048.124-.124.15.006.07-.075.07.053.032-.075.065-.059.145-.022.123-.085"
            id="prefix__path3623"
            fill="none"
            stroke="#fff"
            strokeWidth={0.044}
            strokeLinecap="butt"
            strokeLinejoin="miter"
            strokeMiterlimit={4}
            strokeOpacity={1}
            strokeDasharray="none"
          />
        </g>
      </svg>
    </Fragment>
  );
}

export default SerbiaMap;
